<template>
    <div>
        <BaseListPage
            headline="lang_AZ_LIVE"
            :context="context"
            :alvqa="alvqa"
        >
            <template v-slot:dataTable>
                <BaseDataTableList
                    :headers="headers"
                    :context="context"
                    :alvqa="alvqa"
                >
                    <template v-slot:topSlot><AzLiveTopSlot /></template>

                    <template v-slot:body="{ item }">
                        <ExpandIcon 
                            :isExpanded="item.isExpanded" 
                            :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-expand'"
                        />
                        <td :alvqa="alvqa + '-list-row-' + item.item.id + '-text-venue-name'">
							{{ item.item.name }}
						</td>
                        <td 
                            class="text-right"
                        :alvqa="alvqa + '-list-row-' + item.item.id + '-text-zip'">
							{{ item.item.zip }}
						</td>
                        <td :alvqa="alvqa + '-list-row-' + item.item.id + '-text-city'">
							{{ item.item.city }}
						</td>
                        <td :alvqa="alvqa + '-list-row-' + item.item.id + '-text-address'">
							{{ item.item.addressRow1 }}
						</td>
                        <td :alvqa="alvqa + '-list-row-' + item.item.id + '-text-alvId'">
							{{ item.item.alvId }}
						</td>
                    </template>

                    <template v-slot:expandSlot><AzLiveReadOnly /></template>
                </BaseDataTableList>
            </template>
        </BaseListPage>
    </div>
</template>

<script>
import BaseListPage from '@/components/_base/BaseListPage'
import BaseDataTableList from '@/components/_base/BaseDataTableList'
import AzLiveTopSlot from './AzLiveTopSlot'
import AzLiveReadOnly from './_readonly/AzLiveReadOnly'
import ExpandIcon from '@/components/_buttons/ExpandIcon'

export default {
    name: "AzLiveList",
    components: {
        BaseListPage,
        BaseDataTableList,
        AzLiveTopSlot,
        AzLiveReadOnly,
        ExpandIcon
    },
    data() {
        return {
            context: "AzLive",
            alvqa: "az-live"
        }
    },
    computed: {
        headers() {
            return [
                // {
				// 	text: '', 
				// 	value: 'data-table-select', 
				// 	align: 'center',
				// 	width: "60px",
                //     sortable: false,
				// 	class: 'text-no-wrap'
                // },
                {
                    text: '', 
                    value: 'data-table-expand',
                    align: 'center', 
                    width: "48px",
                    sortable: false,
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_PUBLISHING_SHEETS_CAPTION_SETLIST_EVENT_VENUE'), 
                    value: 'name',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_AZ_PERSONS_CAPTION_ZIP'), 
                    value: 'zip',
                    align: 'right', 
                    sortable: false, 
                    width: '150px',
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_AZ_PERSONS_CAPTION_CITY'), 
                    value: 'city',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_AZ_CAPTION_ADDRESS'), 
                    value: 'addressRow1',
                    align: 'left', 
                    sortable: false, 
                    class: 'text-no-wrap'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_ALVID'), 
                    value: 'alvId',
                    align: 'left', 
                    sortable: false, 
                    width: "170px",
                    class: 'text-no-wrap'
                },
				{
					text: '', 
					value: 'editForm',
					align: 'right',
					sortable: false,
					width: "70px",
					class: 'text-no-wrap'
				}
            ]
        }
    }
}
</script>